
import { useNavigate } from 'react-router-dom';
import { CustomSearch } from '@/shared/components/ui';
import { useFetchPreagendamientos } from '@/shared/actions/erp';
import { useTableColumnsPreagendamientoVentas, useTableFilter } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { IPreagendamiento } from '@/shared/interfaces';
import { Grid } from '@mui/material';
import { EstadosPagoEnumChoice, EstadosPreagendamientoEnumChoice, ROUTER_PATHS } from '@/shared';

export default function VoucherPreagendaPage() {

  const { columnaComprobantePago } = useTableColumnsPreagendamientoVentas({
    estado_preagendamiento: EstadosPreagendamientoEnumChoice.EN_ESPERA,
  });

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    setPagination,

    dateBefore,
    dateAfter,
    onChangeRangeDate,
    cleanFilter

  } = useTableFilter();

  const { pageIndex } = pagination;


  const { isLoading, data: preagendamientoRes,
    isRefetching, } = useFetchPreagendamientos({
      enabled: true,
      params: {
        //identificacion: searchTerm,
        page: pageIndex + 1,
        page_size: 10,
        fecha_creacion_after: dateAfter,
        fecha_creacion_before: dateBefore,
        estado_pago: EstadosPagoEnumChoice.PENDIENTE
      }
    });

  const navigate = useNavigate();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""

          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<IPreagendamiento>
          columns={columnaComprobantePago}
          data={preagendamientoRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={preagendamientoRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          // crud
          onEdit={(row) => {
            navigate(ROUTER_PATHS.contabilidad.revisionVoucherAccionNav + row.id_preagendamiento)
          }}
          canDelete={false}
          positionActionsColumn='first'

        />
      </Grid>
    </Grid>
  );


}

